import React from 'react';
import moment from 'moment';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { NEW_USER_REFERRAL_WINDOW_TIME } from '@src/constants/referral';
import actions from '@src/redux/actions';
import { StyledAdsItem, StyledVoucherBanner } from './index.style';
import CountdownBanner from './CountdownBanner';

const ReferralBanner = () => {
  const { i18n } = useTranslation();
  const { t, language } = i18n;
  const { user } = useSelector((state) => state.auth);
  const referralConfig = useSelector((state) => state.referralConfig);
  const dispatch = useDispatch();

  const { refereePoints, charsPerPoint } = referralConfig || {};
  const refereeCharsReward = refereePoints * charsPerPoint;

  const getCountdownDate = () => {
    const createdAt = moment(user.createdAt);
    const twentyFourHoursLater = createdAt.add(
      NEW_USER_REFERRAL_WINDOW_TIME,
      'day',
    );
    return twentyFourHoursLater.toDate().getTime();
  };

  const renderTitle = () => (
    <Box className="title-wrapper">
      <Typography className="title">
        {t('referralAds', {
          reward: refereeCharsReward.toLocaleString(language),
        })}
      </Typography>
    </Box>
  );

  const renderActionButton = () => (
    <div className="button-wrapper">
      <Button
        className="button"
        onClick={() => {
          dispatch(actions.user.updateIsOpeningRedeemReferralDialog(true));
        }}
      >
        <CountdownBanner date={getCountdownDate()} />
        {`- ${t('enterReferralCode')}`}
      </Button>
    </div>
  );

  return (
    <StyledAdsItem>
      <StyledVoucherBanner isReferral>
        {renderTitle()}
        {renderActionButton()}
      </StyledVoucherBanner>
    </StyledAdsItem>
  );
};

export default ReferralBanner;
